<template>
    <div class="modal" :class="{ 'is-open': open }">
        <div class="modal-box dark">
            <div class="modal-box-header">
                <span class="title">Új reklamáció felvétele</span>
                <button type="button" @click="$emit('close')" class="btn btn-plain btn-plain-wicon">
                    <md-icon>close</md-icon>
                </button>
            </div>
            <div class="modal-box-body">
                <div style="margin-bottom: 0px;" class="input-wrapper">
                    <button
                        @click="$router.push({name: 'ComplaintCreate', hash: '#damage'})"
                        class="btn btn-primary"
                        style="width: 100%; margin-bottom: 15px"
                        type="button">
                        <md-icon>add_circle</md-icon> Új töréskár felvétele
                    </button>

                    <button
                        @click="$router.push({name: 'ComplaintCreate', hash: '#quality'})"
                        class="btn btn-primary"
                        style="width: 100%"
                        type="button">
                        <md-icon>add_circle</md-icon> Új reklamáció felvétele
                    </button>
                </div>
            </div>
        </div>

        <div class="modal-layer"></div>
    </div>
</template>

<script>
import Vue from 'vue'
import {MdIcon} from 'vue-material/dist/components'

Vue.use(MdIcon)

export default {
    name: 'ComplaintModal',
    props: ['open'],

    data() {
        return {
        }
    },

    methods: {

    }
}
</script>

<style lang="scss" scoped>
@import '../../assets/sass/toolkit.scss';
@import '../../assets/sass/ui/input.scss';
@import '../../assets/sass/ui/button.scss';
@import '../../assets/sass/ui/modal.scss';

.modal {
    &-box {
        &-body {
            .input-wrapper {
                margin-top: 15px;
                margin-bottom: 25px;

                .label {
                    font-size: 14px;
                }

                textarea {
                    margin-top: 7px;
                }
            }

            .btn-primary {
                margin-right: 20px;
            }

            .success-message {
                font-size: 15px;
                margin-top: 15px;
                margin-bottom: 20px;
            }
        }
    }
}
</style>
